import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import Logo from "./Logo";
//import { SignInDialog } from "./SignInDialog";

//import { useNavigate } from "react-router-dom";

interface TopMenuProps {
  onScrollToBottom: () => void;
  onScrollToTop: () => void;
  launched: boolean;
}

const TopMenu: React.FC<TopMenuProps> = ({
  //onScrollToBottom,
  onScrollToTop,
  launched,
}) => {
  const theme = useTheme();

  const [scrolled, setScrolled] = useState(false);
  // const navigate = useNavigate();

  /*
  const handleSignInClick = () => {
    navigate("/login"); // Navigate to the login route
  };
*/
  // Function to handle scroll event
  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 100) {
      // Adjust this value based on when you want to change the background
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  // Adding scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: scrolled
          ? "transparent" // Adjust this value for different background colors when scrolled
          : "transparent",
        backdropFilter: scrolled ? "blur(9px)" : "none", // Apply blur effect when scrolled
        boxShadow: "none",
        transition: "all 0.01s ease", // Smooth transition for background color and blur effect
        borderBottom: scrolled
          ? "1px solid rgba(255, 255, 255, 0.05)" // Add border to bottom when not scrolled
          : "none",
      }}
    >
      <Toolbar
        style={{
          justifyContent: "center",
          width: "100%",
          maxWidth: "1700px",
          margin: "0 auto",
        }}
      >
        <Logo onClick={onScrollToTop} />
        {/*<Button color="inherit">Superusers</Button> */}

        {launched && (
          <>
            {/*
            <Button
              size={isMobile ? "small" : "medium"}
              color="inherit"
              variant="outlined"
              sx={{
                mr: "6px",
                borderColor: "transparent",
                "&:hover": {
                  borderColor: "#fff",
                  variant: "outlined",
                },
              }}
              onClick={handleSignInClick}
            >
              Sign in
            </Button>
            */}
            {/* SignInDialog component */}

            {/*
            <Button
              variant="outlined"
              size={isMobile ? "small" : "medium"}
              color="inherit"
              onClick={onScrollToBottom}
              sx={{
                borderColor: "transparent",
                "&:hover": {
                  backgroundColor: "#fff",
                  color: theme.palette.background.paper,
                  borderColor: "#fff",
                },
              }}
            >
              Waitlist
            </Button>
            */}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default TopMenu;
